import {UntypedFormControl, ValidatorFn} from '@angular/forms'

export function imageUploadValidator(): ValidatorFn {
  return function validate(formControl: UntypedFormControl) {
    const imageUrl = formControl.value
    if(!imageUrl.length) {
      return {imageUploadValidator: true}
    }
    return null
  }
}
